import { Notify } from "../notify";

export default () => ({
    loading: false,
    errors: {},
    success: '',

    init() {
        this.$watch('$store.modalStore.activeKey', function(value) {
            if(value) {
                if(document.querySelector('[data-key="' + value + '"] form input') !== null) {
                    document.querySelector('[data-key="' + value + '"] form input').focus();
                }
            }
        });
    },

    form: {
        [':class']() {
            return this.loading ? 'disabled' : '';
        },

        ['@submit.prevent']() {
            this.submit();
        },
    },

    close: {
        ['@click']() {
            let key = this.$root.dataset.key;
            this.$store.modalStore.close(key);
        },
    },

    modal: {
        ['@click.self']() {
            let key = this.$root.dataset.key;
            this.$store.modalStore.close(key)
        },
    },

    async submit() {
        this.loading = true;
        this.success = '';
        let key = this.$root.dataset.key;

        let form = this.$el;
        let formData = new FormData(form);
        formData.append('lang', lang);
        let response = await fetch('/api/' + key, {
            method: 'POST',
            headers: {
                'X-csrf-token': _token
            },
            body: formData,
        });

        if (!response.ok) {
            this.errors.message = lex['form.internal_error'];
            this.loading = false;
            return;
        }

        let result = await response.json();

        this.errors = result.errors;

        if (Object.keys(this.errors).length === 0) {
            if (result.alert !== undefined) {
                this.$dispatch('alert', result.alert);
            }
            
            if(result.redirect !== undefined) {
                const timeout = result.timeout !== undefined ? result.timeout : 100;
                
                setTimeout(() => {
                    window.location = result.redirect;                    
                }, timeout);
            }
        }
        else {
            Notify.error(lex['form.error']);
        }

        this.loading = false;
    }
})
